import React, { useEffect } from "react";
import ListItems from "./ListItems";
import List from "@mui/material/List";
import GridViewIcon from "@mui/icons-material/GridView";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import PaymentsIcon from "@mui/icons-material/Payments";
import SpeakerGroupIcon from "@mui/icons-material/SpeakerGroup";
import ReceiptIcon from '@mui/icons-material/Receipt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import HelpIcon from '@mui/icons-material/Help';
import GroupIcon from '@mui/icons-material/Group';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useDispatch, useSelector } from "react-redux";
import { GetUserRoles } from "../../Redux/Actions/authAction";
import Box from "@mui/material/Box";

const showRebalancingOrders = false; // Set to true to show, false to hide

function Sidebar({ open }) {
  const { userRoles } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(GetUserRoles());
  }, [dispatch]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
        backgroundColor: "#FFFFFF"
      }}
    >
      <List 
        component="nav" 
        style={{ 
          marginTop: "5px", 
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {open ? (
          <>
            <ListItems
              link="/dashboard"
              name="Dashboard"
              icon={<GridViewIcon style={{ color: "#666" }} />}
            />
            <ListItems
              link="/strategy"
              name="Strategies Management"
              icon={<EqualizerIcon style={{ color: "#666" }} />}
            />
            <ListItems
              link="/investor"
              name="Investors Management"
              icon={<GroupIcon style={{ color: "#666" }} />}
            />
            <ListItems
              link="/custodians"
              name="Custodians Management"
              icon={<SpeakerGroupIcon style={{ color: "#666" }} />}
            />
            <ListItems
              link="/accounting"
              name="Accounting"
              icon={<AccountBalanceIcon style={{ color: "#666" }} />}
            />
            {showRebalancingOrders && (
              <ListItems
                link="/orders"
                name="Rebalancing Orders"
                icon={<EqualizerIcon style={{ color: "#666" }} />}
              />
            )}
            <ListItems
              link="/managerorders"
              name="Orders"
              icon={<TrendingUpIcon style={{ color: "#666" }} />}
            />
            <ListItems
              link="/activity"
              name="Activity Logs"
              icon={<PendingActionsIcon style={{ color: "#666" }} />}
            />
            
            {/* Spacer to push Support to bottom */}
            <Box sx={{ flexGrow: 1 }} />
            
            {/* <ListItems
              link="/support"
              name="Support"
              icon={<HelpIcon style={{ color: "#666" }} />}
            /> */}
          </>
        ) : (
          <>
            <ListItems
              link="/dashboard"
              icon={
                <GridViewIcon style={{ marginLeft: "15px", color: "#666" }} />
              }
              mt={true}
            />
            <ListItems
              link="/strategy"
              icon={
                <EqualizerIcon style={{ marginLeft: "15px", color: "#666" }} />
              }
              mt={true}
            />
            <ListItems
              link="/investor"
              icon={
                <GroupIcon style={{ marginLeft: "15px", color: "#666" }} />
              }
              mt={true}
            />
            <ListItems
              link="/custodians"
              icon={
                <SpeakerGroupIcon
                  style={{ marginLeft: "15px", color: "#666" }}
                />
              }
              mt={true}
            />
            <ListItems
              link="/accounting"
              icon={
                <AccountBalanceIcon style={{ marginLeft: "15px", color: "#666" }} />
              }
              mt={true}
            />
            {showRebalancingOrders && (
              <ListItems
                link="/orders"
                icon={
                  <EqualizerIcon style={{ marginLeft: "15px", color: "#666" }} />
                }
                mt={true}
              />
            )}
            <ListItems
              link="/managerorders"
              icon={
                <TrendingUpIcon style={{ marginLeft: "15px", color: "#666" }} />
              }
              mt={true}
            />
            {/* {userRoles?.some(
              (roleObj) => roleObj.role.toLowerCase() === "manager"
            ) && (
              <ListItems
                link="/addmanager"
                icon={
                  <PersonAddIcon
                    style={{ marginLeft: "15px", color: "#666" }}
                  />
                }
                mt={true}
              />
            )} */}
            <ListItems
              link="/activity"
              icon={<PendingActionsIcon style={{ marginLeft: "15px", color: "#666" }} />}
              mt={true}
            />
            
            {/* Spacer to push Support to bottom */}
            <Box sx={{ flexGrow: 1 }} />
            
            {/* <ListItems
              link="/support"
              icon={<HelpIcon style={{ marginLeft: "15px", color: "#666" }} />}
              mt={true}
            /> */}
          </>
        )}
      </List>
    </div>
  );
}

export default Sidebar;
